import { render, staticRenderFns } from "./AddDepartment.vue?vue&type=template&id=6761b41b"
import script from "./AddDepartment.vue?vue&type=script&lang=js"
export * from "./AddDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6761b41b')) {
      api.createRecord('6761b41b', component.options)
    } else {
      api.reload('6761b41b', component.options)
    }
    module.hot.accept("./AddDepartment.vue?vue&type=template&id=6761b41b", function () {
      api.rerender('6761b41b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/AddDepartment.vue"
export default component.exports